import { Row, Col, Button } from "reactstrap";
import React from "react";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import {
  serviceCaller,
  ServiceCallerProps,
  withUserCharities,
  UserCharitiesProps,
  withSuperadminLoginRedirect,
} from "../../../composition";
import { ISortOption } from "../../sortDropdown";
import SortDropdown from "../../sortDropdown";
import ICharity from "../../../../types/services/ICharity";
import BaseInput from "../../../../toolkit/baseInput";
import {
  isCurrentUserAdmin,
  isCurrentUserOnlyCollaborator,
} from "../../../../utils/roleCheck";
import { getCharityProvider, setNewApiKey } from "../../../../utils/fetch";
import * as commonActions from "../../../../utils/actions/common";

interface Props extends ServiceCallerProps, UserCharitiesProps {
  hideSelection: () => void;
}

interface State {
  selectedCharity: ISortOption;
  newKey: string;
  provider: string;
  busyLoading: boolean;
}

class ApiKeyManager extends React.PureComponent<Props, State> {
  charityOptions: ISortOption[] = [
    { key: "default", show: "Select a Charity", colName: "" },
  ];

  state = {
    selectedCharity: this.charityOptions[0],
    newKey: "",
    provider: "",
    busyLoading: false,
  };

  componentDidMount() {
    this.props.hideSelection();
    if (this.props.charities) {
      this.fillCharityDropdown();
    }
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.charities !== prevProps.charities) {
      this.fillCharityDropdown();
    }
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }
  }

  fillCharityDropdown() {
    this.charityOptions = [
      { key: "default", show: "Select a Charity", colName: "" },
    ];
    this.props.charities.forEach((charity: ICharity) => {
      if (
        charity.id !== "superadmin" &&
        charity.id !== "abc" &&
        charity.id !== "donation-reader" &&
        !charity.disableGive
      ) {
        this.charityOptions.push({
          key: charity.id,
          show: charity.name,
          colName: "",
        });
      }
    });
  }

  sortCharityChange = (option: ISortOption) => {
    this.setState(
      {
        selectedCharity: option,
        provider: null,
        busyLoading: true,
      },
      async () => {
        await this.getCharityProvider();
      }
    );
  };

  getCharityName = charityId => {
    let charityName = charityId;
    this.props.charities.forEach(charity => {
      if (charity.id === charityId) {
        charityName = charity.name;
      }
    });
    return charityName;
  };

  changeApiKey = e => {
    this.setState({
      newKey: e.target.value,
    });
  };

  setDefaultKey = async () => {
    if (
      confirm("Are you sure you want to set the default key for this charity?")
    ) {
      const setComplete = await setNewApiKey(
        this.props.config.adminServiceUrl,
        this.state.selectedCharity.key,
        "default",
        this.props.serviceAccessToken
      );
      if (setComplete) {
        alert("Default Key Set");
        this.setState(
          {
            newKey: "",
          },
          async () => {
            await this.getCharityProvider();
          }
        );
      }
    }
  };

  setNewKey = async () => {
    if (
      confirm(
        "Are you sure you want to change the sms api key for this charity?"
      )
    ) {
      const setComplete = await setNewApiKey(
        this.props.config.adminServiceUrl,
        this.state.selectedCharity.key,
        this.state.newKey,
        this.props.serviceAccessToken
      );
      if (setComplete) {
        alert("New Api Key Set");
        this.setState(
          {
            newKey: "",
          },
          async () => {
            await this.getCharityProvider();
          }
        );
      }
    }
  };

  getCharityProvider = async () => {
    if (this.state.selectedCharity.key !== "default") {
      const charityProvider = await getCharityProvider(
        this.props.config.adminServiceUrl,
        this.state.selectedCharity.key,
        this.props.serviceAccessToken
      );
      this.setState({
        provider: charityProvider,
        busyLoading: false,
      });
    }
  };

  render() {
    return (
      <main className={s.main}>
        <div className={s.container}>
          <Row>
            <Col xs={12} md={{ size: 8, offset: 2 }}>
              <h2>Manage MMS Api Key</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={{ size: 8, offset: 2 }}>
              <Row className={s.marginBot}>
                <Col xs={12} sm={6}>
                  <SortDropdown
                    options={this.charityOptions}
                    sortChanged={this.sortCharityChange}
                  />
                </Col>
                <Col xs={12} sm={6} className={s.provider}>
                  {this.state.provider}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={{ size: 8, offset: 2 }}>
              <label className={s.titleLabel}>New Api Key</label>
              <BaseInput
                type="text"
                name="apiKey"
                id="apiKey"
                value={this.state.newKey}
                onChange={this.changeApiKey}
              />
            </Col>
          </Row>
          <Col md={{ size: 8, offset: 2 }}>
            <Row>
              <Col xs={12} className={s.centered}>
                <Button
                  id={"cancelBackButton"}
                  onClick={this.setDefaultKey}
                  className={s.button}
                  disabled={
                    this.state.selectedCharity.key === "default" ||
                    !isCurrentUserAdmin(this.props.currentCharity) ||
                    this.state.busyLoading
                  }
                >
                  Set Default
                </Button>
                &nbsp;
                <Button
                  id={"nextButton"}
                  onClick={this.setNewKey}
                  className={s.button}
                  disabled={
                    this.state.selectedCharity.key === "default" ||
                    !isCurrentUserAdmin(this.props.currentCharity) ||
                    this.state.busyLoading ||
                    !this.state.newKey ||
                    this.state.newKey.length === 0
                  }
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Col>
        </div>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  hideSelection: () => {
    dispatch(commonActions.hideSelection());
  },
});

export default connect<Props>(
  null,
  mapDispatchToProps
)(
  serviceCaller(
    withSuperadminLoginRedirect(withUserCharities(withStyles(s)(ApiKeyManager)))
  )
);
